// @ts-ignore
/* eslint-disable */

/**
 * API Module - All API requests are organized here
 */
export { http, request } from '@/utils';
export type { RequestOptions } from '@/utils';

// Auth APIs
export { login, outLogin, currentUser, changePassword } from './auth';

// Tenant APIs
export { listTenants, createTenant, updateTenant, deleteTenant } from './tenant';

// Role APIs
export {
    listRoles,
    createRole,
    updateRole,
    deleteRole,
    saveRolePermissions,
} from './role';

// Org APIs
export { listOrgs, createOrg, updateOrg, deleteOrg } from './org';

// Member APIs
export {
    listMembers,
    createMember,
    updateMember,
    deleteMember,
    saveMemberRoles,
} from './member';

// Upload API
export { uploadFile } from './upload';
